<template>
  <section class="px-4">
    <h2>Your box</h2>
    <ul v-if="slots.length" class="
      flex justify-around flex-wrap align-center m-auto 
      mx-auto
      py-1 
      border border-grey border-solid"
      :style="{maxWidth: boxWidth}">
          <li 
            v-for="(slot,j) in slots" :key="`slot-${j}`"
            class="
            rounded-full w-24 h-24 overflow-hidden 
            bg-center bg-no-repeat bg-cover
            border-2 border-solid
            justify-center items-center flex
            m-1
            p-2
          ">
            <cupcake-slot :sku="slot" />
          </li>
    </ul>
  </section>
</template>

<script>
import CupcakeSlot from './CupcakeSlot';
import { chunk, fill, flatten, find } from 'lodash'
export default {
  props: {
    sku: {},
    flavours: {}
  },
  components: {
    CupcakeSlot
  },
  computed: {
    boxWidth() {
      if(this.slots.length == 4) {
        return "calc(7.5rem * 2)"
      } else if(this.slots.length == 6) {
        return "calc(7.5rem * 3)"
      } else {
        return "calc(7.5rem * 4)"
      }
    },
    chunks() {
      if(this.slots.length < 12) {
        return chunk(this.slots, this.slots.length / 2)
      } else if(this.slots.length < 24) { 
        return chunk(this.slots, this.slots.length / 3)
      } else {
        return chunk(this.slots, this.slots.length / 4)
      }
    },
    product() {
      return find(this.$root.$data.products, {sku: this.sku})
    },
    slots() {
      if(!this.sku) {
        return []    
      }
      let out = Array(this.product.slots)
      if(this.flavours.length == 0) {
        return fill(out, "PICK")
      }
      let chunks = chunk(out, Math.floor(out.length / this.flavours.length))
      return flatten(chunks.map((o,i) => {
        if(this.flavours[i]) {
          return fill(o, this.flavours[i])
        } else {
          return fill(o,"PICK")
        }
      }))
    }
  }

}
</script>
